import links from '@/constants/links.js';

export default {
    list: [
        {
            id: 1,
            title: 'components.downloads.list.google.title',
            icon: "fab fa-google-drive",
            img: 'https://gm.goz.fun/wp-content/uploads/2023/03/gd-logo.png',
            subtitle: 'components.downloads.list.google.subtitle',
            brief: 'components.downloads.list.google.brief',
            link: links.downloads.googleDrive,
            flexExtraSmall: 12,
            flexSmall: 12,
            flexMedium: 12,
            flexLarge: 4,
            isActive: true,
        },
        {
            id: 2,
            title: 'components.downloads.list.meganz.title',
            icon: "fal fa-cloud-download-alt",
            img: 'https://gm.goz.fun/wp-content/uploads/2023/03/mediafire-logo.png',
            subtitle: 'components.downloads.list.meganz.subtitle',
            brief: 'components.downloads.list.meganz.brief',
            link: links.downloads.megaNz,
            flexExtraSmall: 12,
            flexSmall: 12,
            flexMedium: 12,
            flexLarge: 4,
            isActive: true,
        },
        {
            id: 3,
            title: 'components.downloads.list.medafire.title',
            icon: "fal fa-cloud-download-alt",
            img: 'https://gm.goz.fun/wp-content/uploads/2023/03/meganz-logo.png',
            subtitle: 'components.downloads.list.medafire.subtitle',
            brief: 'components.downloads.list.medafire.brief',
            link: links.downloads.mediaFire,
            flexExtraSmall: 12,
            flexSmall: 12,
            flexMedium: 12,
            flexLarge: 4,
            isActive: true,
        },
        {
            id: 4,
            title: 'components.downloads.list.onedrive.title',
            icon: "fal fa-download",
            img: 'https://gm.goz.fun/wp-content/uploads/2023/03/onedrive-logo.png',
            subtitle: 'components.downloads.list.onedrive.subtitle',
            brief: 'components.downloads.list.onedrive.brief',
            link: links.downloads.oneDrive,
            flexExtraSmall: 12,
            flexSmall: 12,
            flexMedium: 12,
            flexLarge: 4,
            isActive: true,
        },
        {
            id: 5,
            title: 'components.downloads.list.direct.title',
            icon: "fal fa-cloud-download-alt",
            img: 'https://gm.goz.fun/wp-content/uploads/2023/03/default-profile-pic.jpg',
            subtitle: 'components.downloads.list.direct.subtitle',
            brief: 'components.downloads.list.direct.brief',
            link: links.downloads.direct,
            flexExtraSmall: 12,
            flexSmall: 12,
            flexMedium: 12,
            flexLarge: 4,
            isActive: true,
        },
        {
            id: 6,
            title: 'components.downloads.list.fileissue.title',
            icon: "fal fa-engine-warning",
            img: 'https://gm.goz.fun/wp-content/uploads/2023/03/default-profile-pic.jpg',
            subtitle: 'components.downloads.list.fileissue.subtitle',
            brief: 'components.downloads.list.fileissue.brief',
            link: links.downloads.files,
            flexExtraSmall: 12,
            flexSmall: 12,
            flexMedium: 12,
            flexLarge: 4,
            isActive: true,
        },
        {
            id: 7,
            title: 'components.downloads.list.launcherissue.title',
            icon: "fal fa-engine-warning",
            img: 'https://gm.goz.fun/wp-content/uploads/2023/03/default-profile-pic.jpg',
            subtitle: 'components.downloads.list.launcherissue.subtitle',
            brief: 'components.downloads.list.launcherissue.brief',
            link: links.downloads.gameExe,
            flexExtraSmall: 12,
            flexSmall: 12,
            flexMedium: 12,
            flexLarge: 4,
            isActive: true,
        },
        {
            id: 8,
            title: 'components.downloads.list.patchissue.title',
            icon: "fal fa-window",
            img: 'https://gm.goz.fun/wp-content/uploads/2023/03/default-profile-pic.jpg',
            subtitle: 'components.downloads.list.patchissue.subtitle',
            brief: 'components.downloads.list.patchissue.brief',
            link: links.downloads.windowIssue,
            flexExtraSmall: 12,
            flexSmall: 12,
            flexMedium: 12,
            flexLarge: 4,
            isActive: true,
        },
        {
            id: 9,
            title: 'components.downloads.list.improveexp.title',
            icon: "fal fa-star",
            img: 'https://gm.goz.fun/wp-content/uploads/2023/03/default-profile-pic.jpg',
            subtitle: 'components.downloads.list.improveexp.subtitle',
            brief: 'components.downloads.list.improveexp.brief',
            link: "https://goz.fun/page/landing?slug=improving-your-experience-in-gods-of-zushin",
            flexExtraSmall: 12,
            flexSmall: 12,
            flexMedium: 12,
            flexLarge: 4,
            isActive: true,
        },
    ]
}
